<h2 class="mat-dialog-title" mat-dialog-title color="warn">{{title}}</h2>
<mat-dialog-content>
  <p>{{description}}</p>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-raised-button class="mat-elevation-z10" color="primary" style="width: 100px; border-radius: 0px;"
    (click)="closeDialog()"> OK
  </button>
</mat-dialog-actions>